<div class="main-Content pagination">
    <h3>Over Due Tickets</h3>
        <table mat-table [dataSource]="dataSource" class="elevation">
    
            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->
          
            <!-- Position Column -->
            <ng-container matColumnDef="no">
              <th mat-header-cell *matHeaderCellDef style="padding-left:20px"> Ticket</th>
              <td mat-cell *matCellDef="let element ; let i = index;" style="height: 50px;padding-left:35px"> {{paginator.pageSize * paginator.pageIndex + i + 1}} </td>
            </ng-container>
          
            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef style="padding-left:5px">Ticket Name  </th>
              <td mat-cell *matCellDef="let element" style="padding-left:5px"><a style="color: #7ACEFF;" href="" [routerLink] = "['/TicketDetail',element.ticketID]" > {{element.ticketName}} </a></td>
              <router-outlet></router-outlet>
            </ng-container>
          
            <!-- Weight Column -->
            <ng-container matColumnDef="assignedTo">
              <th mat-header-cell *matHeaderCellDef style="padding-left:20px"> Assigned To </th>
              <td mat-cell *matCellDef="let element" style="padding-left:20px"> {{element.assingedTo}} </td>
            </ng-container>
          
            <!-- Symbol Column -->
            <ng-container matColumnDef="startDate">
              <th mat-header-cell *matHeaderCellDef style="padding-left:20px"> Start Date </th>
              <td mat-cell *matCellDef="let element" style="padding-left:20px"> {{element.startDateString}} </td>
            </ng-container>
          
              <!-- Symbol Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef style="padding-left:20px"> Status</th>
                <!-- <td mat-cell *matCellDef="let element"> {{element.ticketStatusName}} </td> -->
                <td mat-cell *matCellDef="let element" style="padding-left:35px">                   
                  <span  *ngIf="element.ticketStatusName == 'Completed'" #tooltip="matTooltip" matTooltip="Completed"  class="blue-bg FontWeight500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                      <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
                        <path id="Path_6947" data-name="Path 6947" d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z" transform="translate(2 2)" fill="#5e70e8"/>
                      </g>
                    </svg>
                  </span>
                  <span  *ngIf="element.ticketStatusName == 'Open'" #tooltip="matTooltip" matTooltip="Open"  class="green-bg FontWeight500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                      <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
                        <path id="Path_6947" data-name="Path 6947" d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z" transform="translate(2 2)" fill="#2fda50"/>
                      </g>
                    </svg>
                  </span>
                  <span  *ngIf="element.ticketStatusName == 'InProgress'" #tooltip="matTooltip" matTooltip="InProgress"  class="orange-bg FontWeight500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                      <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
                        <path id="Path_6947" data-name="Path 6947" d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z" transform="translate(2 2)" fill="#ffb000"/>
                      </g>
                    </svg> 
                  </span>
                  <span  *ngIf="element.ticketStatusName == 'Pending'" #tooltip="matTooltip" matTooltip="Pending"  class="red-bg FontWeight500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                      <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
                        <path id="Path_6947" data-name="Path 6947" d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z" transform="translate(2 2)" fill="#ff4b3d"/>
                      </g>
                    </svg>
                  </span>
                 </td>
              </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <table>
            <tr *ngIf="loading" style="height: 300px;background-color: #fff;">
              <td>
                <mat-progress-spinner
                strokeWidth="3"
                [color] = "color"
                [mode] = "mode"
                [value] = "value"
                [diameter] = "diameter"
                style="margin: auto;"
                >
             </mat-progress-spinner>
              </td>
            </tr>
            <tr *ngIf="total==0">
              <td colspan="12" style="background-color: rgb(249, 216, 216); color: Red; text-align: center; height: 50px;">No tickets exist! Awesome</td>
            </tr>
          </table>  
          <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
          </mat-paginator>         
    </div>
    
    
    